import { computed, effect, Injectable } from '@angular/core';
import { OrganizationSettingTypeEnum } from '@libs/types/src/organization/enum/organization-setting-type.enum';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import {
    OrganizationSettingsObject,
} from '@libs/types/src/organization/object-type/organization/organization-settings.object';
import { setActiveIntegrations } from '../../../store/organization/organization.actions';
import { featureOn } from '../../../../../feature-flag';

@Injectable()
export class OrganizationDetailPageStore extends ComponentStoreV2Factory {

    public primaryOrganizationCenter = computed(() => {
        return this.data.getOrganization()?.centers?.find((it) => it.primary) || null;
    });

    public nonPrimaryOrganizationCenters = computed(() => {
        return this.data.getOrganization()?.centers?.filter((it) => !it.primary) || [];
    });

    public allowedSettings = computed<OrganizationSettingTypeEnum[]>(() => {
        return [
            // OrganizationSettingTypeEnum.SYSTEM_SETTINGS, // TODO noone knows what is does and what works
            ...this.isAllowed('system.update')() ? [
                OrganizationSettingTypeEnum.EMAILING_SETTINGS,
            ] : [],
            ...this.isAllowed('emailClient.read')() ? [
                OrganizationSettingTypeEnum.EMAIL_CLIENT_SETTINGS,
            ] : [],
            OrganizationSettingTypeEnum.PASSWORD_RESET,
            ...this.isAllowed('organization.update')() && featureOn.TRASH ? [
                OrganizationSettingTypeEnum.TRASH_SETTINGS,
            ] : [],
            ...this.isAllowed('madoProject.read')() ? [
                OrganizationSettingTypeEnum.MADO,
                OrganizationSettingTypeEnum.MADO_SETTINGS,
                OrganizationSettingTypeEnum.MADO_CREDIT_AGREEMENTS,
            ] : [],
            ...this.isAllowed('service.read')() ? [
                OrganizationSettingTypeEnum.HEALTHCARE_SOCIAL_SETTINGS,
                OrganizationSettingTypeEnum.SOFTWARE602_SIGNING,
            ] : [],
            ...this.isAllowed('donation.update')() ? [
                OrganizationSettingTypeEnum.DARUJME,
                OrganizationSettingTypeEnum.SPORITELNA,
                OrganizationSettingTypeEnum.COLLECTION_CATEGORY,
                OrganizationSettingTypeEnum.DONATION_FORM,
                OrganizationSettingTypeEnum.RAIFFEISEN,
                OrganizationSettingTypeEnum.WEB_GATEWAY,
            ] : [],
        ];
    });

    public existingSettings = computed<OrganizationSettingsObject[]>(() => {
        return (this.data.getOrganizationSettings()?.items || []).filter((settings: OrganizationSettingsObject) => {
            return settings.key !== OrganizationSettingTypeEnum.TRASH_SETTINGS || featureOn.TRASH;
        });
    });

    public unusedSettings = computed(() => {
        const allowed = this.allowedSettings();
        const existing = this.existingSettings();

        const used = existing.map((it) => it.key);
        return allowed.filter((it) => !used.includes(it));
    });

    constructor() {
        super();
        effect(() => {
            const settings = this.data.getOrganizationSettings();
            if (!settings) return;

            this.globalGlobalStore.organizationStore.settings.set(settings?.['items'] || []);
            this.store!.dispatch(setActiveIntegrations({
                activeIntegrations: (settings?.['items'] || [])
                    .filter((i: OrganizationSettingsObject) => i.active)
                    .reduce((acc: Record<string, { data: string }>, i: OrganizationSettingsObject) => {
                        acc[i.key] = i;
                        return acc;
                    }, {}),
            }));
        });
    }

}
